import React from 'react'
import PropTypes from 'prop-types'
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types'
import { renderRichText } from 'gatsby-source-contentful/rich-text'

// Styles
import {
  Super,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  Title,
  TextBody,
} from '../TextStyles'
import Button from '../Button'
import Table from '../Table'
import {
  ListItem,
  OrderedList,
  RichTextMain,
  UnorderedList,
} from './index.style'
import { colors } from '../../styles/vars/colors.style'

const RichTextPlain = ({
  content,
  delay,
  delayEm,
  forceHeading,
  superHeading,
  upgradeHeading,
  hasHeadingOne,
  button,
}) => {
  const options = {
    renderMark: {
      [MARKS.BOLD]: text => <strong>{text}</strong>,
      [MARKS.ITALIC]: text => <em>{text}</em>,
      [MARKS.CODE]: text => <i className={'sup'}>{text}</i>,
    },
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        if (children[0].length === 1 && children[0][0] === '') return null
        return <TextBody>{children}</TextBody>
      },

      [BLOCKS.HEADING_1]: (node, children) => {
        if (superHeading) {
          return <Super as={forceHeading ? `h1` : ``}>{children}</Super>
        } else {
          return <Heading1 as={forceHeading ? `h1` : ``}>{children}</Heading1>
        }
      },

      [BLOCKS.HEADING_2]: (node, children) => {
        if (upgradeHeading) {
          return (
            <Heading1
              as={
                forceHeading && hasHeadingOne ? `h1` : forceHeading ? `h2` : ``
              }
            >
              {children}
            </Heading1>
          )
        } else {
          return (
            <Heading2
              as={
                forceHeading && hasHeadingOne ? `h1` : forceHeading ? `h2` : ``
              }
            >
              {children}
            </Heading2>
          )
        }
      },

      [BLOCKS.HEADING_3]: (node, children) => {
        if (upgradeHeading) {
          return (
            <Heading2
              as={
                forceHeading && hasHeadingOne ? `h1` : forceHeading ? `h2` : ``
              }
            >
              {children}
            </Heading2>
          )
        } else {
          return (
            <Heading3
              as={
                forceHeading && hasHeadingOne ? `h1` : forceHeading ? `h2` : ``
              }
            >
              {children}
            </Heading3>
          )
        }
      },

      [BLOCKS.HEADING_4]: (node, children) => {
        return <Heading4 as={forceHeading ? `h4` : ``}>{children}</Heading4>
      },

      [BLOCKS.HEADING_5]: (node, children) => {
        return <Title>{children}</Title>
      },

      [BLOCKS.UL_LIST]: (node, children) => (
        <UnorderedList>{children}</UnorderedList>
      ),

      [BLOCKS.OL_LIST]: (node, children) => (
        <OrderedList>{children}</OrderedList>
      ),

      [BLOCKS.LIST_ITEM]: (node, children) => {
        return <ListItem>{children}</ListItem>
      },
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        return <Table content={node.data.target.table.tableData} />
      },
      [INLINES.HYPERLINK]: (node, children) => {
        if (button) {
          return (
            <Button href={node.data.uri} color={colors.light} theme="outline">
              {node.content[0].value}
            </Button>
          )
        } else {
          return (
            <a href={node.data.uri} target="_blank" rel="noreferrer">
              {children}
            </a>
          )
        }
      },
    },
    renderText: text =>
      React.Children.toArray(
        text.split('\n').map((t, i) =>
          i > 0 ? (
            <>
              <br />
              {t}
            </>
          ) : (
            t
          )
        )
      ),
  }

  return <RichTextMain>{renderRichText(content, options)}</RichTextMain>
}

RichTextPlain.propTypes = {
  content: PropTypes.object,
  delay: PropTypes.number,
  delayEm: PropTypes.bool,
  forceHeading: PropTypes.bool,
  superHeading: PropTypes.bool,
  upgradeHeading: PropTypes.bool,
  button: PropTypes.bool,
}

RichTextPlain.defaultProps = {
  delay: 0,
}

export default RichTextPlain
